import {
  BrowserRouter,
  Routes as RoutesWrapper,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import SessionTimeoutWarning from "./components/SessionTimeoutWarning";
import Login from "./pages/Auth/login/Login";
import Register from "./pages/Auth/register/Register";
import ActivateAccount from "./pages/Auth/ativar_conta/Activation";
import ForgotPassword from "./pages/Auth/esqueceu_senha/ForgotPassword";
import ChangePassword from "./pages/Auth/mudar_senha/ChangePassword";
import VerifyMfa from "./pages/Auth/verify_mfa/VerifyMfa";
import SearchScreen from "./pages/TelaPrincipal/SearchScreen";
import ProfileUsuarioComum from "./pages/ProfileUsuarioComum/perfil_comum/ProfileUsuarioComum";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleProtectedRoute from "./components/RoleProtectedRoute";
import TestAuth from "./components/TestAuth";
import CollaborateUsuarioComum from "./pages/ProfileUsuarioComum/colaborar/CollaborateUsuarioComum";
import OtherInformationUsuarioComum from "./pages/ProfileUsuarioComum/outras_informacoes/OtherInformationUsuarioComum";
import ChangePasswordUsuarioComum from "./pages/ProfileUsuarioComum/mudar_senha/ChangePasswordUsuarioComum";
import ProfileColaborador from "./pages/ProfileColaborador/perfil_colaborador/ProfileColaborador";
import OtherInformationColaborador from "./pages/ProfileColaborador/outras_informacoes_colaborador/OtherInformationColaborador";
import ChangePasswordColaborador from "./pages/ProfileColaborador/mudar_senha_colaborador/ChangePasswordColaborador";
import CollaborateColaborador from "./pages/ProfileColaborador/colaborar_colaborador/CollaborateColaborador";
import MinhasColaboracoesColaborador from "./pages/ProfileColaborador/minhas_colaboracoes/MinhasColaboracoesColaborador";
import CollaborationReadOnlyUser from "./pages/ProfileColaborador/minhas_colaboracoes/CollaborationReadOnlyUser";
import MinhasColaboracoesUsuarioComum from "./pages/ProfileUsuarioComum/minhas_colaboracoes/MinhasColaboracoesUsuarioComum";
// Admin pages
import ProfileAdmin from "./pages/TelaAdministrador/profile/ProfileAdmin";
import DashboardAdmin from "./pages/TelaAdministrador/dashboard/DashboardAdmin";
import OtherInformationAdmin from "./pages/TelaAdministrador/profile/OtherInformationAdmin";
import ChangePasswordAdmin from "./pages/TelaAdministrador/mudar_senha/ChangePasswordAdmin";
import CollaborateAdmin from "./pages/TelaAdministrador/colaborar/CollaborateAdmin";
import RequestsTableAdmin from "./pages/TelaAdministrador/colaborar/RequestTableAdmin";
import CollaborateRequestAdmin from "./pages/TelaAdministrador/colaborar/CollaborationRequestAdmin";
import CollaborateReadOnlyAdmin from "./pages/TelaAdministrador/colaborar/CollaborationReadOnlyAdmin";
import RequestTableCollaborateAdmin from "./pages/TelaAdministrador/solicitacoes_colaboracao/RequestTableCollaborateAdmin";
import ImageRequestsTable from "./pages/TelaAdministrador/colaborar/ImageRequestsTable";
import UserAccountsAdmin from "./pages/TelaAdministrador/contas_usuarios/UserAccountsAdmin";
import Home from "./pages/Home/Home";
import Layout from "./components/common/Layout";
import ImageTermsPage from "./pages/Policies/ImageTermsPage";

const Routes = () => {
  const router = () => {
    return (
      <>
        {/* Rota raiz - redireciona para home */}
        <Route path="/" element={<Navigate to="/home" replace />} />

        {/* Rotas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/activate-account" element={<ActivateAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ChangePassword />} />
        <Route path="/verify-mfa" element={<VerifyMfa />} />
        <Route path="/test" element={<TestAuth />} />
        <Route path="/home" element={<Home />} />
        <Route path="/termos-de-uso" element={<ImageTermsPage />} />

        {/* Rotas protegidas */}
        <Route
          path="/searchscreen"
          element={
            <ProtectedRoute>
              <SearchScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-usuario-comum"
          element={
            <ProtectedRoute>
              <ProfileUsuarioComum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/outras-informacoes-usuario-comum"
          element={
            <ProtectedRoute>
              <OtherInformationUsuarioComum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/colaborar-usuario-comum"
          element={
            <ProtectedRoute>
              <CollaborateUsuarioComum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mudar-senha-usuario-comum"
          element={
            <ProtectedRoute>
              <ChangePasswordUsuarioComum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/minhas-colaboracoes-usuario-comum"
          element={
            <ProtectedRoute>
              <MinhasColaboracoesUsuarioComum />
            </ProtectedRoute>
          }
        />
        <Route
          path="/colaboracao-usuario-comum/:id"
          element={
            <ProtectedRoute>
              <CollaborationReadOnlyUser />
            </ProtectedRoute>
          }
        />
        {/* Colaborador */}
        <Route
          path="/profile-colaborador"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <ProfileColaborador />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/outras-informacoes-colaborador"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <OtherInformationColaborador />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mudar-senha-colaborador"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <ChangePasswordColaborador />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/colaborar-colaborador"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <CollaborateColaborador />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/minhas-colaboracoes-colaborador"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <MinhasColaboracoesColaborador />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/colaboracao-colaborador/:id"
          element={
            <RoleProtectedRoute
              allowed={["Colaborador", "Admin"]}
              redirectTo="/"
            >
              <CollaborationReadOnlyUser />
            </RoleProtectedRoute>
          }
        />
        {/* Admin */}
        <Route
          path="/dashboard-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <DashboardAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/profile-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <ProfileAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/outras-informacoes-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <OtherInformationAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/mudar-senha-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <ChangePasswordAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/colaborar-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <CollaborateAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/solicitacoes-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <RequestsTableAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/solicitacao-colaboracao-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <RequestTableCollaborateAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/solicitacao-colaboracao-admin/:id"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <CollaborateRequestAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/colaboracao-admin/:id"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <CollaborateReadOnlyAdmin />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/solicitacao-imagens-admin/:requestId"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <ImageRequestsTable />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/contas-usuarios-admin"
          element={
            <RoleProtectedRoute allowed={["Admin"]} redirectTo="/">
              <UserAccountsAdmin />
            </RoleProtectedRoute>
          }
        />
        {/* Rota legacy para compatibilidade com URL antiga */}
        <Route
          path="/solicitacoes-colaborador"
          element={<Navigate to="/minhas-colaboracoes-colaborador" replace />}
        />
      </>
    );
  };

  return (
    <AuthProvider>
      <BrowserRouter>
        <SessionTimeoutWarning warningMinutes={10} />
        <RoutesWrapper>
          <Route element={<Layout />}>{router()}</Route>
        </RoutesWrapper>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default Routes;
